import React from 'react'

function Smiley ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 336 336'>
      <circle cx='104' cy='136' r='8' />
      <circle cx='232' cy='136' r='8' />
      <path d='M168,0A168,168,0,1,0,336,168,168,168,0,0,0,168,0ZM80,136a24,24,0,1,1,24,24A24,24,0,0,1,80,136Zm166,85.34a105,105,0,0,1-155.92,0A8,8,0,1,1,102,210.67a89,89,0,0,0,132.08,0A8,8,0,1,1,246,221.34ZM232,160a24,24,0,1,1,24-24A24,24,0,0,1,232,160Z' />
    </svg>
  )
}

Smiley.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Smiley
